import styled, { keyframes } from 'styled-components'

import { AnnounceMode, IClinAnnounceBarProps } from './ClinToastBar'
import { ClinTheme } from '../../ClinTheme'
import { mediaQueryDown } from '../../utils/mediaQuery'

const desktopUpBreakpoint = ClinTheme.breakpoints[2]

const getColorForMode = (mode: AnnounceMode): string => {
  switch (mode) {
    case AnnounceMode.Information:
      return ClinTheme.colors.deliveryDateBackground
    case AnnounceMode.Success:
      return ClinTheme.colors.lightenGreen
    case AnnounceMode.Error:
      return ClinTheme.colors.redInvalid
    case AnnounceMode.Warning:
      return ClinTheme.colors.orangeWarn
  }
}

interface IStyledIconProps {
  height?: number
  width?: number
}

const StyledSlideIn = keyframes`
0% {
  opacity: 0;
  transform: translateY(-${ClinTheme.space[3]}px);
}
100% {
   opacity: 1;
    transform: translateY(0px);
  }
`

export const StyledClinToastBar = styled.div<IClinAnnounceBarProps>`
  display: flex;
  justify-content: space-between;
  align-items: ${({ iconPosition }) => iconPosition ?? 'center'};
  animation: ${StyledSlideIn} 0.15s ease-out;
  padding: ${ClinTheme.space[3]}px ${ClinTheme.space[4]}px;
  border-radius: ${ClinTheme.radii[3]}px;
  background-color: ${({ mode }) => mode && getColorForMode(mode)};
  color: ${ClinTheme.colors.black};
  word-break: break-word;
  max-width: 1140px;
  margin: ${({ marginTop }) => marginTop ?? 20}px auto
    ${({ marginBottom }) => marginBottom ?? 0}px;
  height: ${({ height }) => height ?? ClinTheme.space[5]}px;

  ${mediaQueryDown(desktopUpBreakpoint)} {
    height: 100%;
  }
`

export const StyledMessage = styled.div({
  marginRight: 'auto',
  flex: '1 0 0'
})

export const StyledCloseIcon = styled.a({
  cursor: 'pointer'
})

export const StyledIcon = styled.img<IStyledIconProps>(
  {
    objectFit: 'contain',
    objectPosition: 'left'
  },
  ({ height, width }: IStyledIconProps) => ({
    marginRight: '12px',
    height: height ? `${height}px` : '20px',
    width: width ? `${width}px` : '27px'
  })
)

export const StyledDismiss = styled.div({
  color: ClinTheme.colors.primaryLight,
  fontSize: ClinTheme.fontSizes[2],
  lineHeight: ClinTheme.fontSizes[2],
  fontWeight: ClinTheme.fontWeights.medium,
  fontStyle: 'normal',
  letterSpacing: ClinTheme.space[0],
  cursor: 'pointer',
  textAlign: 'center'
})
